export default __webpack_public_path__ + "static/media/re.043df54e.jpg";